// Mock data for BOT Bakery Landing Page

export const heroData = {
  tagline: "BOT Bakery - Chicago's First All-Vegan, Gluten-Free Bakery",
  headline: "Artisanal Sweets & Savory Delights",
  subheadline: "Handcrafted with organic, local ingredients since 2007",
  ctaText: "Order Now",
  ctaPhone: "773-495-4615",
  secondaryCta: "View Menu"
};

export const storyData = {
  title: "The BOT Bakery Story",
  subtitle: "Making History, One Delicious Bite at a Time",
  content: "Founded by Elizabeth (BettyBot) Alper in 2007, BOT Bakery made history as the world's first all-vegan, all gluten-free bakery. What started as a revolutionary idea has blossomed into Chicago's premier destination for organic, allergen-friendly baked goods.",
  highlights: [
    { label: "Founded", value: "2007" },
    { label: "Specialty", value: "100% Vegan & GF" },
    { label: "Approach", value: "Organic & Local" }
  ]
};

export const productsData = {
  title: "What We Offer",
  services: [
    {
      id: 1,
      icon: "ShoppingBag",
      title: "Farmers Markets",
      description: "Find us at local Chicago farmers markets featuring our seasonal selections of cupcakes, cookies, breads, and specialty items.",
      features: ["Fresh Weekly", "Seasonal Varieties", "Market Exclusive Items"]
    },
    {
      id: 2,
      icon: "Truck",
      title: "Local Delivery",
      description: "Order directly and get our delicious vegan, gluten-free treats delivered to your location in the Chicago area.",
      features: ["Chicago Area", "Fresh Baked", "Custom Orders"]
    },
    {
      id: 3,
      icon: "UtensilsCrossed",
      title: "Event Catering",
      description: "Make your special events memorable with our artisanal vegan and gluten-free catering. Perfect for weddings, parties, and corporate events.",
      features: ["Custom Menus", "All Dietary Needs", "Professional Service"]
    }
  ]
};

export const specialtiesData = {
  title: "Our Specialties",
  items: [
    "100% Organic Ingredients",
    "Vegan & Gluten-Free",
    "Corn-Free",
    "Nightshade-Free",
    "Local Farm Partnerships",
    "Unique Seasonal Flavors"
  ]
};

export const eventsData = {
  title: "Community Events",
  subtitle: "Building Chicago's Vegan Community",
  events: [
    {
      id: 1,
      title: "Chicago Vegan Bakers Market",
      season: "Winter Edition",
      description: "After two successful seasons in 2025 and 2026, the Chicago Vegan Bakers Market returns! A celebration of Chicago's finest vegan bakers, featuring unique treats from around the city.",
      schedule: "January 2027",
      frequency: "Annual Winter Event",
      instagram: "@chicagoveganbakers",
      image: "winter"
    },
    {
      id: 2,
      title: "Chicago Vegan Farmers Market",
      season: "Summer Edition",
      description: "All-vegan farmers market featuring local produce, artisan goods, and of course, BOT Bakery's fresh baked treats!",
      schedule: "Starting July 2026",
      frequency: "Weekly Throughout Summer",
      instagram: "@chicagoveganfarmersmarket",
      image: "summer"
    }
  ]
};

export const galleryData = {
  title: "Handcrafted with Love",
  subtitle: "Every item is made with care, passion, and the finest organic ingredients",
  images: [
    {
      id: 1,
      url: "https://customer-assets.emergentagent.com/job_bot-bakery-landing/artifacts/dukz9ova_image000000%20%286%29.jpg",
      alt: "BOT Bakery Farmers Market Display",
      caption: "Fresh at the Farmers Market"
    },
    {
      id: 2,
      url: "https://customer-assets.emergentagent.com/job_bot-bakery-landing/artifacts/abw7pi7t_image000000.png%20%283%29.jpg",
      alt: "Chocolate Swirl Cupcake",
      caption: "Rich Chocolate Perfection"
    },
    {
      id: 3,
      url: "https://customer-assets.emergentagent.com/job_bot-bakery-landing/artifacts/bryu0gfe_image000000%20%287%29.jpg",
      alt: "Herb Garden Cupcakes",
      caption: "Fresh Herb Infused Delights"
    },
    {
      id: 4,
      url: "https://customer-assets.emergentagent.com/job_bot-bakery-landing/artifacts/jxk4giwd_image000000%20%288%29.jpg",
      alt: "Artisan Triangle Cookies",
      caption: "Handcrafted Specialty Cookies"
    },
    {
      id: 5,
      url: "https://customer-assets.emergentagent.com/job_bot-bakery-landing/artifacts/jn6c1ks9_image000000%20%289%29.jpg",
      alt: "Sugar Dusted Donuts",
      caption: "Sweet Morning Treats"
    },
    {
      id: 6,
      url: "https://customer-assets.emergentagent.com/job_bot-bakery-landing/artifacts/lawg7fpb_image000000%20%2810%29.jpg",
      alt: "Double Chocolate Loaf Breads",
      caption: "Decadent Chocolate Loaves"
    },
    {
      id: 7,
      url: "https://customer-assets.emergentagent.com/job_bot-bakery-landing/artifacts/3r5i8b4j_image000000%20%2811%29.jpg",
      alt: "Cinnamon Swirl Pastries",
      caption: "Artisan Swirl Creations"
    },
    {
      id: 8,
      url: "https://customer-assets.emergentagent.com/job_bot-bakery-landing/artifacts/x8o7q39q_image000000.png%20%284%29.jpg",
      alt: "Flower Shaped Glazed Donuts",
      caption: "Colorful Glazed Blossoms"
    },
    {
      id: 9,
      url: "https://customer-assets.emergentagent.com/job_bot-bakery-landing/artifacts/q7h1d3fq_image000000.png%20%282%29.jpg",
      alt: "Betty at BOT Bakery Booth",
      caption: "Meet Betty at the Market"
    },
    {
      id: 10,
      url: "https://customer-assets.emergentagent.com/job_bot-bakery-landing/artifacts/8pglp0bx_image000000%20%284%29.jpg",
      alt: "Fresh Farmers Market Produce",
      caption: "Local Farm Partners"
    }
  ]
};

export const contactData = {
  title: "Ready to Order?",
  subtitle: "Text or call Betty directly to place your order or discuss catering for your special event",
  phone: "773-495-4615",
  email: "botbakery@gmail.com",
  address: "2614 E. 79th Street, Chicago, IL 60649",
  hours: "By Appointment & Farmers Markets",
  websites: {
    bakery: "botbakery.com",
    shop: "bettybotshop.com"
  },
  socialMedia: {
    instagram: "@bettybotbakery",
    instagramBakers: "@chicagoveganbakers",
    instagramFarmers: "@chicagoveganfarmersmarket",
    website: "www.bettybotshop.com"
  }
};

export const testimonialsData = {
  title: "What People Say",
  testimonials: [
    {
      id: 1,
      name: "Sarah M.",
      text: "Finally, a bakery where I can enjoy everything! The cupcakes are incredible - you'd never know they're gluten-free and vegan!",
      rating: 5
    },
    {
      id: 2,
      name: "Michael R.",
      text: "BOT Bakery catered our wedding and exceeded every expectation. Guests couldn't believe everything was vegan and GF!",
      rating: 5
    },
    {
      id: 3,
      name: "Jennifer K.",
      text: "As someone with multiple food allergies, BOT Bakery is a dream come true. Betty's creations are both safe and absolutely delicious!",
      rating: 5
    }
  ]
};
